$.Redactor.prototype.imageeditor = function () {
	return {
        getTemplate: function() {
            return String()
            + '<section id="redactor-modal-image-edit">'
            + '<table style="width: 260px"><tr><td style="width: 150px"><label>Ширина</label><input type="text" id="redactor-image-width" style="width: 100px" /></td><td><label>Высота</label><input type="text" id="redactor-image-height" style="width: 100px" /></td></tr></table>'
            + '<label>' + this.lang.get('title') + '</label>'
            + '<input type="text" id="redactor-image-title" />'
            + '<label class="redactor-image-link-option">' + this.lang.get('link') + '</label>'
            + '<input type="text" id="redactor-image-link" class="redactor-image-link-option" aria-label="' + this.lang.get('link') + '" />'
            + '<label class="redactor-image-link-option"><input type="checkbox" id="redactor-image-link-blank" aria-label="' + this.lang.get('link_new_tab') + '"> ' + this.lang.get('link_new_tab') + '</label>'
            + '<label class="redactor-image-position-option">' + this.lang.get('image_position') + '</label>'
            + '<select class="redactor-image-position-option" id="redactor-image-align" aria-label="' + this.lang.get('image_position') + '">'
            + '<option value="none">' + this.lang.get('none') + '</option>'
            + '<option value="left">' + this.lang.get('left') + '</option>'
            + '<option value="center">' + this.lang.get('center') + '</option>'
            + '<option value="right">' + this.lang.get('right') + '</option>'
            + '</select>'
            + '</section>';
        },
		init: function () {
            this.modal.addTemplate('imageEdit', this.imageeditor.getTemplate());
		}
	};
};